import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { Calendar, MapPin, ChevronRight, Sparkles } from "lucide-react";

/**
 * Compact hero band shown on landing page when an upcoming event exists.
 * Falls back to null silently when there is no upcoming event.
 */
export default function NextEventBanner() {
  const [event, setEvent] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/public/adoption-events/next`)
      .then((r) => {
        if (!cancelled) setEvent(r.data.event);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!event) return null;

  const dateLabel = (() => {
    try {
      return new Date(event.event_date).toLocaleDateString("tr-TR", {
        weekday: "long",
        day: "numeric",
        month: "long",
      });
    } catch {
      return event.event_date;
    }
  })();

  const dogCount = event.featured_dogs?.length || event.featured_dog_ids?.length || 0;

  return (
    <section
      className="relative bg-gradient-to-r from-amber-50 via-rose-50 to-amber-50 border-y border-amber-200/60"
      data-testid="next-event-banner"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-5">
        <Link to="/etkinlikler" className="block group">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div className="w-10 h-10 rounded-full bg-primary/15 flex items-center justify-center flex-shrink-0">
                <Sparkles className="w-5 h-5 text-primary" strokeWidth={1.5} />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-xs uppercase tracking-wider text-primary font-semibold mb-0.5 truncate">
                  {event.title}
                  {event.subtitle ? <span className="opacity-70"> · {event.subtitle}</span> : null}
                </p>
                <div className="font-heading text-sm md:text-lg text-foreground flex flex-col md:flex-row md:items-center md:gap-x-3">
                  <span className="inline-flex items-center gap-1.5 min-w-0">
                    <Calendar className="w-4 h-4 text-primary flex-shrink-0" />
                    <span className="truncate">{dateLabel} · {event.start_time}–{event.end_time}</span>
                  </span>
                  <span className="inline-flex items-center gap-1.5 min-w-0">
                    <MapPin className="w-4 h-4 text-primary flex-shrink-0" />
                    <span className="truncate">{event.location_name}, {event.location_city}</span>
                  </span>
                </div>
                {dogCount > 0 && (
                  <p className="text-xs text-muted-foreground mt-1 truncate">
                    {dogCount} can seni bekliyor — gel tanış, ister sahiplen ister destek ol.
                  </p>
                )}
              </div>
            </div>
            <div className="flex items-center gap-1 text-primary font-medium group-hover:gap-2 transition-all">
              Etkinliği Keşfet 💃
              <ChevronRight className="w-4 h-4" />
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
}
